import { STATES } from "./states";

export interface TaxRate {
  id: string;
  state_id: string;
  federal_tax_rate: number;
  state_tax_rate: number;
  notes?: string;
  states?: { id: string; name: string; slug: string; abbreviation: string };
}

const RATES: Record<string, number> = {
  AL: 5.0, AK: 0, AZ: 4.5, AR: 5.9, CA: 0, CO: 4.4, CT: 6.99, DE: 6.6, DC: 8.95,
  FL: 0, GA: 5.49, HI: 0, ID: 5.8, IL: 4.95, IN: 3.15, IA: 6.0, KS: 5.0, KY: 4.5,
  LA: 4.25, ME: 7.15, MD: 8.95, MA: 5.0, MI: 4.25, MN: 9.85, MS: 5.0, MO: 4.95, MT: 6.75,
  NE: 5.0, NV: 0, NH: 0, NJ: 8.0, NM: 5.9, NY: 10.9, NC: 4.75, ND: 2.9, OH: 3.99,
  OK: 4.75, OR: 9.9, PA: 3.07, RI: 5.99, SC: 7.0, SD: 0, TN: 0, TX: 0, UT: 4.85,
  VT: 8.75, VA: 5.75, WA: 0, WV: 6.5, WI: 7.65, WY: 0,
};

export const TAX_RATES: TaxRate[] = STATES.filter((s) => s.has_lottery).map((s) => ({
  id: `tax-${s.slug}`,
  state_id: s.id,
  federal_tax_rate: 24,
  state_tax_rate: RATES[s.abbreviation] ?? 0,
  notes: (RATES[s.abbreviation] ?? 0) === 0 ? `${s.name} does not tax lottery winnings.` : undefined,
  states: { id: s.id, name: s.name, slug: s.slug, abbreviation: s.abbreviation },
}));